import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { TipoOrgano } from '../servicio/servicio.service';
import { AutoridadesXTipoDTO, RegistrarUsuarioCommand, itemOrganos, ResponseRegistroUsuario } from "../../commons/class/OrganosXTipo.class"
import { AltaUsuarioService } from './altaUsuario.service';
import { AlertService } from '../../commons/components/alert/alert.service';
import { AlertComponent } from "../../commons/components/alert/alert.component";
import { AppModule } from '../../app-module';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'oaj-alta-usuario-itx',
  templateUrl: 'altaUsuario.component.html',
  styleUrls: ['altaUsuario.component.css'],
  imports: [AlertComponent, AppModule],
  providers: [AltaUsuarioService, AlertService]
})

export class altaUsuarioComponent implements OnInit {

  searchOrgano = '';

  currentPage = 1;
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  loading = false;
  Iniciales = '';
  filterOrgano = '';

  //Objetos para llenado de comboBox de tipo organo
  TiposOrganos: TipoOrgano[] = [];
  selectedOrganismoId: number | null = null;


  //Tabla organos
  selectedOrganos: any[] = [];
  listOrganos!: AutoridadesXTipoDTO[];
  //listOrganos: Observable<AutoridadesXTipoDTO[]> = of([]);

  OrganosOIJLst!: any[];
  filtroListOrganos!: AutoridadesXTipoDTO[];
  //listOrganos: Observable<AutoridadesXTipoDTO[]> = of([]);

  //Tabla de Registro usuarios
  RegistroUsuario!: ResponseRegistroUsuario[];

  //manejo de mensaje error
  organosError = '';
  errorMessage = '';

  //Ocultar tablas
  mostrarTablaOrganos = true;
  mostrarTablaUsuarios = false;

  private alertService: AlertService = inject(AlertService);
  private Service: AltaUsuarioService = inject(AltaUsuarioService);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);


  ngOnInit(): void {
    this.cargarTiposOrganos();
  }

  onItemChange(event: any): void {
    this.selectedOrganismoId = event.target.value;
  }

  /**
   * Carga el catalogo de tipos de organos para llenar el comboBox, al seleccionar un tipo de organo se cargan los organos correspondientes a ese tipo
   */
  private cargarTiposOrganos(): void {
    this.loading = true;
    this.Service.getTiposOrganismoOIJ().subscribe({
      next: (response: any) => {

        if (response.succcess) {

          this.TiposOrganos = response.data;
        }
        this.loading = false;
        this.changeDetectorRef.detectChanges();

      },
      error: (error) => {
        console.error(JSON.stringify(error));
        this.organosError = 'No fue posible cargar el catalogo de tipos de organos.';
        this.loading = false;
      }
    });
  }

  /**
   * Funcion para cargar los organos dependiendo del tipo de organo seleccionado, se muestra un mensaje de error si no se selecciona un tipo de organo o si la consulta falla
   * @param tipoOrganoSelect 
   */
  BuscarOrganos(tipoOrganoSelect: number): void {

    this.errorMessage = '';
    if (tipoOrganoSelect === null || tipoOrganoSelect === undefined) {
      this.errorMessage = 'Selecciona un tipo de organo del catalogo.';
      return;
    }
    this.loading = true;
    this.Service.getOrganosxTipo(tipoOrganoSelect).subscribe({
      next: (response: any) => {

        if (response.succcess) {
          // this.listOrganos = response.data;
          this.listOrganos = response.data;
          this.OrganosOIJLst = response.data;
        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
        }
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      },
      error: (error) => {
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
        this.loading = false;
      }
    });

  }

  /**
   * Funcion para registrar los usuarios dependiendo de los organos seleccionados, se muestra un mensaje de error si no se capturan las iniciales o si no se selecciona ningun organo, o si la consulta falla
   * 
   */
  registroUsuarios(): void {

    if (this.Iniciales.trim() === '') {
      this.alertService.warn("No ha capturado las iniciales, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    if (this.selectedOrganos.length == 0) {
      this.alertService.warn("No ha seleccionado un organo", { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    this.loading = true;

    const request: RegistrarUsuarioCommand = new RegistrarUsuarioCommand();
    request.tipoOrganismoid = this.selectedOrganismoId!;
    request.siglas = this.Iniciales;

    this.selectedOrganos.forEach(element => {
      const orgTip: itemOrganos = new itemOrganos();

      orgTip.CatOrganismoId = element["organismId"];
      orgTip.CatOrganismoName = element["organismName"];
      orgTip.correo = element["correo"];

      request.CatOrganismos.push(orgTip!);
    });

    this.mostrarTablaOrganos = false;
    this.mostrarTablaUsuarios = true;
    this.Service.RegistrarUsuarios(request).subscribe({
      next: (response: any) => {

        if (response.succcess) {

          if (response.data.length != 0) {


            this.RegistroUsuario = response.data["listUsuarios"];
            this.alertService.success("Se registraron los usuarios.", { autoClose: true, keepAfterRouteChange: false });
          }
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
          this.loading = false;
        }
      },
      error: (error) => {
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
        this.loading = false;
      }
    });

  }

  /**
   * Funcion para seleccionar o deseleccionar todos los organos mostrados en la tabla, dependiendo del estado del checkbox, se muestra un mensaje de error si no se selecciona ningun organo, o si la consulta falla
   * @param event 
   */
  toggleAll(event: any) {
    const isChecked = event.target.checked;

    this.filtroListOrganos.forEach(item => {
      item.selected = isChecked;
    });
    this.updateSelectedItems(); // Opcional: actualizar lista de seleccionados
  }

  /**
   * Funcion para actualizar la lista de organos seleccionados, se llama cada vez que se selecciona o deselecciona un organo, o cuando se selecciona o deselecciona todos los organos, se muestra un mensaje de error si no se selecciona ningun organo, o si la consulta falla
   */
  updateSelectedItems() {
    this.selectedOrganos = this.filtroListOrganos.filter(item => item.selected);
  }

  /**
   * Funcion para cargar los organos dependiendo del tipo de organo seleccionado, se muestra un mensaje de error si no se selecciona un tipo de organo o si la consulta falla
   * @param event 
   */
  onChangeOrgano(event: any): void {
    this.selectedOrganismoId = Number(event);
    this.BuscarOrganos(this.selectedOrganismoId);
  }

  /**
   * Funcion para seleccionar o deseleccionar un organo, dependiendo del estado del checkbox, se muestra un mensaje de error si no se selecciona ningun organo, o si la consulta falla
   * @param event 
   */
  onCheckboxChange(event: any): void {

    if (event.selected) {
      // Añadir al array de seleccionados si no está
      if (!this.selectedOrganos.includes(event)) {
        this.selectedOrganos.push(event);
      }
    } else {
      // Remover del array de seleccionados
      this.selectedOrganos = this.selectedOrganos.filter(selected => selected !== event);
    }
  }

  /**
   * Funcion para aplicar la paginacion a la tabla de organos, se llama cada vez que se cambia de pagina, se muestra un mensaje de error si no se selecciona ningun organo, o si la consulta falla
   */
  applyPagination() {
    //const startIndex = (this.currentPage - 1) * this.pageSize;
    //const endIndex = startIndex + this.pageSize;
    //this.listOrganos = this.listOrganos.slice(startIndex, endIndex);
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Funcion para cambiar de pagina en la tabla de organos, se llama cada vez que se cambia de pagina, se muestra un mensaje de error si no se selecciona ningun organo, o si la consulta falla
   * @param newPage 
   */
  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.applyPagination();
  }

  /**
   * funcion para exportar a excel la tabla de usuarios registrados, se muestra un mensaje de error si no hay registros para exportar, o si la consulta falla
   */
  exportToExcel(): void {
    if (this.RegistroUsuario.length <= 0) {
      this.alertService.warn('No hay registros para exportar');
      return;
    }

    const data: any[] = [];
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(`ReporteUsuarios`);
    const valores = [];
    valores[1] = 'Reporte de usuarios registrados';

    const rowTitulo = worksheet.addRow(valores);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rowTitulo.eachCell((cell, number) => {
      cell.font = { size: 18, bold: true, color: { argb: 'FFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: '5B4E97'
        }
      };
    });
    /*rowTitulo.eachCell((cell, number) => {
      cell.font = { size: 18, bold: true, color: { argb: 'FFFFFF' } }, cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: '5B4E97'
        }
      };
    });*/

    worksheet.mergeCells('A1:V1');
    worksheet.mergeCells('A2:E2');
    worksheet.mergeCells('A3:E3');
    worksheet.mergeCells('A4:E4');

    worksheet.columns = [
      { key: 'A', width: 10 },
      { key: 'B', width: 50 },
      { key: 'C', width: 20 },
      { key: 'D', width: 20 },
      { key: 'E', width: 20 },
    ];


    const headers = ['ID Organo', 'Nombre del organo', 'Usuario', 'Password'];


    const rowHeaders = worksheet.addRow(headers);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rowHeaders.eachCell((cell, number) => {
      cell.font = { bold: true, color: { argb: 'FFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: '00008B'
        }
      };
    });
    /*rowHeaders.eachCell((cell, number) => {
      cell.font = { bold: true, color: { argb: 'FFFFFF' } }, cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: '00008B'
        }
      };
    });*/


    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.RegistroUsuario.map((item, index) => {
      const temp2 = [
        item.catOrganismoId,
        item.nombreOrgano,
        item.usuario,
        item.password
      ];
      data.push(temp2);

      const rowtemp2 = worksheet.addRow(temp2);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      rowtemp2.eachCell({ includeEmpty: true }, function (cell, number) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

      });



    });


    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, 'ReporteNotificaciones.xlsx');
    });
  }

}
